import { useMutation } from "@tanstack/react-query";
import { deleteEvent } from "supabase/events";
import { queryClient } from "utils";

type UseDeleteEventParams = {
  uid: string;
};

export const useDeleteEvent = (onSuccess: () => any) => {
  const mutation = useMutation({
    mutationFn: ({ uid }: UseDeleteEventParams) => {
      return deleteEvent({ uid });
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["events"],
      });

      onSuccess();
    },
  });

  return mutation;
};
